'use strict';

function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
};
/**
 * Tells if two values are exactly similar
 * @param val1
 * @param val2
 * @returns {boolean}
 */


exports["default"] = function (val1, val2) {
  var isSame = true;

  if ((typeof val1 === 'undefined' ? 'undefined' : _typeof(val1)) === 'object' && (typeof val2 === 'undefined' ? 'undefined' : _typeof(val2)) === 'object') {
    if (val1.length !== val2.length) return false;
    val1.forEach(function (val, i) {
      if (val2[i] !== val) isSame = false;
    });
  } else {
    isSame = val1 === val2;
  }

  return isSame;
};